function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M55.5 56.1943V1.16919H0.5V56.1943H55.5Z",
  fill: "white",
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_62_372)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.9997 37.4442C29.8312 37.4442 31.316 38.0567 31.316 39.4249C31.316 40.7933 29.8312 42.3994 27.9997 42.3994C26.1682 42.3994 24.6836 40.7933 24.6836 39.4249C24.6836 38.0567 26.1682 37.4442 27.9997 37.4442Z",
  stroke: "black",
  strokeMiterlimit: 2.613,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5107 53.3741C19.2227 54.8812 23.6482 55.5991 28.0014 55.5991C37.6096 55.5991 47.5696 52.1018 49.4338 44.3412C50.0601 41.734 48.2325 40.2597 47.2345 36.1124C46.3748 32.5396 48.2927 29.893 46.6392 28.3049C44.9871 26.7182 33.4598 16.9606 46.2781 1.8278M9.72617 1.82922C22.5423 16.9613 11.0157 26.7183 9.3636 28.3049C7.71028 29.893 9.62817 32.5396 8.76838 36.1124C7.77044 40.2597 5.94289 41.734 6.56917 44.3412C6.83496 45.4478 7.266 46.4676 7.83661 47.4031M19.6145 17.4208C21.9624 14.5096 23.4918 15.3366 28.0014 15.3366C32.5112 15.3366 34.0406 14.5096 36.3884 17.4208",
  stroke: "black",
  strokeMiterlimit: 2.613,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7769 15.5228C2.56559 -19.2526 5.15526 21.9695 8.75228 29.3525",
  stroke: "black",
  strokeMiterlimit: 2.613,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.2065 29.5634C30.2065 31.8461 31.8746 33.3906 33.6109 34.3935C38.3066 37.2054 38.1744 41.2746 38.0421 42.234C37.9098 43.1934 36.3887 44.0536 34.5369 45.5092C32.6852 46.9648 30.2381 47.6926 28.0019 45.5092C25.7658 47.6926 23.3187 46.9648 21.467 45.5092C19.6152 44.0536 18.0941 43.1934 17.9617 42.234C17.8295 41.2746 17.6972 37.2054 22.3929 34.3935C24.1293 33.3906 25.7973 31.8461 25.7973 29.5634C25.7973 28.3453 26.7844 27.3578 28.0019 27.3578C29.2195 27.3578 30.2065 28.3453 30.2065 29.5634Z",
  stroke: "black",
  strokeMiterlimit: 2.613,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 42.3961V45.5088",
  stroke: "black",
  strokeMiterlimit: 2.613,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.2148 15.5408C53.4238 -19.2427 50.8503 21.9129 47.2565 29.3379",
  stroke: "black",
  strokeMiterlimit: 2.613,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.6719 29.8779H35.6741",
  stroke: "black",
  strokeWidth: 2.5,
  strokeMiterlimit: 22.926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.3281 29.8779H20.3303",
  stroke: "black",
  strokeWidth: 2.5,
  strokeMiterlimit: 22.926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.8105 47.2222V48.6596C30.8105 50.207 29.5463 51.4731 28.001 51.4731C26.4558 51.4731 25.1914 50.207 25.1914 48.6596V47.2222",
  stroke: "black",
  strokeMiterlimit: 2.613,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1953 51.0005H11.1968",
  stroke: "black",
  strokeMiterlimit: 2.613,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 57
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.e85306817a9bda868a26a8b0cf8b2919.svg";
export { ForwardRef as ReactComponent };